import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import LeadManagementDashboard from '../../components/admin/LeadManagementDashboard';

const LeadsPage: React.FC = () => {
  return (
    <AdminLayout>
      <LeadManagementDashboard />
    </AdminLayout>
  );
};

export default LeadsPage; 